import {Criteria, CriteriaTypeMap, Filter} from '../types';

export function entriesToFilters(entries: [Criteria, CriteriaTypeMap[Criteria]][]): Filter[] {
  return entries.map(([key, value]) => ({key, value}));
}
